import { useEffect } from 'react';
import { IconFileUpload } from '@tabler/icons-react';
import { Button, Card, Form, Input, Row, Upload } from 'antd';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';

import { appRoute } from 'app/railways/router/routes';
import { Stack } from 'app/ui';

// eslint-disable-next-line mobx/missing-observer
const FileInput = ({ onChange }: { onChange?: (file: any) => void }) => {
  return (
    <Upload.Dragger
      maxCount={1}
      beforeUpload={() => false}
      onChange={({ file }) => {
        if (file.status === 'removed') return onChange && onChange(null);
        console.log({ file });
        onChange && onChange(file);
      }}
    >
      <p className="ant-upload-drag-icon">
        <IconFileUpload />
      </p>
      <p>Нажмите по области или перетащите файл шаблона для загрузки</p>
    </Upload.Dragger>
  );
};

type FormFields = { name: string; file: any };

type ReportTemplateFormProps = {
  reportId: number;
  value?: Pick<FormFields, 'name'>;
  onSubmit?: (fields: FormFields) => void;
  fileRequired?: boolean;
};
export const ReportTemplateForm = observer(
  ({
    value,
    reportId,
    onSubmit,
    fileRequired = true,
  }: ReportTemplateFormProps) => {
    const [form] = Form.useForm();

    useEffect(() => {
      form.setFieldsValue(value);
    }, [form, value]);

    return (
      <Form layout="vertical" onFinish={onSubmit} form={form}>
        <Stack>
          <Card size="small" title="Данные шаблона">
            <Form.Item
              name="name"
              label="Название отчета"
              wrapperCol={{ span: 12 }}
              rules={[
                {
                  required: true,
                  message: 'Пожалуйста, введите имя отчета',
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="file"
              label="Файл шаблона"
              wrapperCol={{ span: 12 }}
              rules={[
                {
                  required: fileRequired,
                  message: 'Пожалуйста, выберите файл шаблона',
                },
              ]}
            >
              <FileInput />
            </Form.Item>
          </Card>

          <Card size="small">
            <Row justify="space-between" align="middle">
              <Link to={appRoute.REPORT_EDIT.buildPath({ id: reportId })}>
                Открыть редактор шаблона
              </Link>
              <Button type="primary" htmlType="submit">
                Сохранить
              </Button>
            </Row>
          </Card>
        </Stack>
      </Form>
    );
  },
);
